export const useDasShareLayout = () => {
  return inject('$das-share-layout', {
    setState: data => {}
  });
};